var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabRecents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119 0c33 0 62 13 84 35 21 21 35 51 35 84s-13 62-35 84c-21 21-51 35-84 35s-62-13-84-35C13 181 0 152 0 119S13 56 35 35C56 13 86 0 119 0zm-10 60c0-4 3-6 7-6s7 3 7 6v60l45 27c3 2 4 6 2 9s-6 4-9 2l-48-28c-2-1-4-3-4-6V60zm85-16C174 25 148 13 119 13S63 25 44 44C25 63 13 90 13 119s12 56 31 75c19 19 45 31 75 31s56-12 75-31c19-19 31-45 31-75s-12-56-31-75z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabRecents);
export default __webpack_public_path__ + "static/media/tab-recents.667c5a41.svg";
export { ForwardRef as ReactComponent };